function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import ProgressRing from 'components/ProgressRing';
import Button from 'components/Form/Button';
import ImportIcon from 'svg/import.svg';
import CheckNegativeIcon from 'svg/check-negative.svg';
import ExclamationNegativeIcon from 'svg/exclamation-negative.svg';
import Link from 'components/Link';
import App from 'modules/App';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from './ImportPatientDatabase.pcss';
var _React_PureComponent;
class ImportPatientDatabase extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        if (!this.props.isInProgress) {
            const { database, clinicMembership } = this.props;
            this.props.onCheckImport(database, clinicMembership);
        }
    }
    onSetImportErrorsList(evt) {
        evt.preventDefault();
        this.props.onSetComponent('ImportErrorsList');
    }
    get infoMessage() {
        const { importPatientDatabaseProgress, isWorking } = this.props;
        if (importPatientDatabaseProgress === 100) {
            return messages.infos.importPatientDatabaseFinished;
        }
        if (isWorking) {
            return messages.infos.importPatientDatabaseInProgress;
        }
        return messages.infos.importPatientDatabase;
    }
    get closeBtnMessage() {
        const { importPatientDatabaseProgress, isWorking, isClosing } = this.props;
        if (importPatientDatabaseProgress === 100) {
            return messages.buttons.close;
        }
        if (isClosing) {
            return messages.buttons.closing;
        }
        if (isWorking) {
            return messages.buttons.pauseAndClose;
        }
        return messages.buttons.close;
    }
    get importBtnMessage() {
        const { importPatientDatabaseProgress, successCount, errorCount, isWorking } = this.props;
        if (importPatientDatabaseProgress === 100) {
            return messages.buttons.importFinished;
        }
        if (isWorking) {
            return messages.buttons.importInProgress;
        }
        if (successCount + errorCount > 0) {
            return messages.buttons.resumeImport;
        }
        return messages.buttons.import;
    }
    renderErrorsListLink() {
        if (!this.props.errorCount) {
            return null;
        }
        return /*#__PURE__*/ _jsxs(Link, {
            to: "",
            onClick: (evt)=>this.onSetImportErrorsList(evt),
            children: [
                "(",
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.showErrorsList)),
                ")"
            ]
        });
    }
    renderSummary() {
        const { importPatientDatabaseProgress, successCount, errorCount, isWorking } = this.props;
        if (!importPatientDatabaseProgress && !isWorking) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.summary__item, {
                        [styles['summary__item--active']]: successCount
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(CheckNegativeIcon, {
                            className: cn(styles.summary__icon, {
                                [styles['summary__icon--success']]: successCount
                            })
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "col text--bold",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.patientsImportedSuccessfully))
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "col-auto text--muted",
                            children: successCount
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.summary__item, {
                        [styles['summary__item--active']]: errorCount
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(ExclamationNegativeIcon, {
                            className: cn(styles.summary__icon, {
                                [styles['summary__icon--error']]: errorCount
                            })
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "col text--bold",
                            children: [
                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.patientsImportedWithErrors)),
                                ' ',
                                this.renderErrorsListLink()
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "col-auto text--muted",
                            children: errorCount
                        })
                    ]
                })
            ]
        });
    }
    render() {
        const { importPatientDatabaseProgress, database, clinicMembership, isClosing, isWorking } = this.props;
        const { infoMessage, closeBtnMessage, importBtnMessage } = this;
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "modal__info my-4",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, infoMessage), {
                        values: {
                            btnLabel: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, importBtnMessage)),
                            supportEmail: /*#__PURE__*/ _jsx("a", {
                                href: `mailto:${App.constants.CONTACT_EMAIL}`,
                                children: App.constants.CONTACT_EMAIL
                            })
                        }
                    }))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "d-flex justify-content-center w-100 mb-5",
                    children: /*#__PURE__*/ _jsx(ProgressRing, {
                        radius: 120,
                        stroke: 15,
                        progress: importPatientDatabaseProgress,
                        isInProgress: isWorking,
                        StartIcon: ImportIcon
                    })
                }),
                this.renderSummary(),
                /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(Button, {
                                styleModifier: "quaternary",
                                labelMessage: closeBtnMessage,
                                className: "btn--block mt-4",
                                isDisabled: isClosing,
                                onClick: ()=>this.props.onCancel()
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(Button, {
                                styleModifier: "primary",
                                labelMessage: importBtnMessage,
                                className: "btn--block btn--filled mt-4",
                                isDisabled: this.props.isInProgress || this.props.importPatientDatabaseProgress === 100,
                                isInProgress: this.props.isInProgress && !this.props.isWorking,
                                onClick: ()=>this.props.onStartImport(database, clinicMembership)
                            })
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(ImportPatientDatabase, "propTypes", {
    // Explicit props
    database: PropTypes.oneOf(Object.keys(App.constants.PATIENT_DATABASES)),
    clinicMembership: shapes.clinicMembership,
    importPatientDatabaseProgress: PropTypes.number,
    isClosing: PropTypes.bool,
    isInProgress: PropTypes.bool,
    isWorking: PropTypes.bool,
    openModalId: PropTypes.string,
    // Implicit props
    successCount: PropTypes.number,
    errorCount: PropTypes.number,
    // Explicit actions
    onSetComponent: PropTypes.func,
    onCancel: PropTypes.func,
    // Implicit actions
    onCheckImport: PropTypes.func,
    onStartImport: PropTypes.func
});
const mapStateToProps = (state)=>({
        successCount: selectors.importPatientDatabaseSuccessCount(state),
        errorCount: selectors.importPatientDatabaseErrorCount(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onCheckImport: (database, clinicMembership)=>dispatch(actions.checkImportPatientDatabase(database, clinicMembership)),
        onStartImport: (database, clinicMembership)=>dispatch(actions.importPatientDatabase(database, clinicMembership))
    });
const ConnectedImportPatientDatabase = connect(mapStateToProps, mapDispatchToProps)(ImportPatientDatabase);
export default withStyles(styles)(ConnectedImportPatientDatabase);
